/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_PInputs */

const es_faq_cta_p = /** @type {(inputs: Faq_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora nuestra flota de barcos o añade el tuyo para empezar a generar ingresos`)
};

const gl_faq_cta_p = /** @type {(inputs: Faq_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora a nosa frota ou engade o teu barco para comezar a xerar ingresos`)
};

const en_faq_cta_p = /** @type {(inputs: Faq_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse our fleet or list your boat to start earning`)
};

/**
* | output |
* | --- |
* | "Browse our fleet or list your boat to start earning" |
*
* @param {Faq_Cta_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_cta_p = /** @type {((inputs?: Faq_Cta_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_cta_p(inputs)
	if (locale === "en") return en_faq_cta_p(inputs)
	return es_faq_cta_p(inputs)
});